<template>
  <div class="renderer-layout-teaser">
    <!--div v-if="context.state === API_STATES.error">
      <strong>Oops, da ist wohl etwas schief gelaufen.</strong>
    </div-->

    <ul
      v-if="isFetchingPreviousContent"
      class="layout-teaser renderer-layout-teaser__placeholder renderer-layout-teaser__placeholder--previous"
    >
      <template v-for="index in placeholderLength" :key="`upper-${index}`">
        <li
          class="layout-teaser__item layout-teaser__item--tablet-width-50"
          :class="getItemClassByIndex(index - 1)"
        >
          <dpc-teaser-placeholder />
        </li>
      </template>
    </ul>
    <!--
      {{ pages.map(page => page.page) }}
    -->
    <ul class="layout-teaser renderer-layout-teaser__page">
      <template v-for="(page, pageIndex) in pages" :key="`page-${page.page}`">
        <!--
          <template
          v-if="
            pages.length > 1 &&
            ((newPageIsNext && isLastPageIndex(pageIndex)) ||
              (newPageIsPrevious && isFirstPageIndex(pageIndex)))
          "
        >
          <li role="seperator" class="render-layout-teaser__seperator">
            Inhalt {{ pages[0].teaser.length * (lastNewPage - 1) + 1 }} bis
            {{
              pages[0].teaser.length * (lastNewPage - 1) + page.teaser.length
            }}
          </li>
        </template>
        <li
        v-if="pageIndex > 0"
          tabindex="-1"
          role="seperator"
          class="render-layout-teaser__seperator"
          :data-page="page.page"
        >
          Seite {{ page.page }}
        </li>
      -->

        <template
          v-for="(teaser, teaserIndex) in page.teaser"
          :key="`${teaser.meta.id}-${teaserIndex}`"
        >
          <transition-group name="renderer-layout-teaser" appear>
            <li
              :key="`${teaser.meta.id}-${teaserIndex}-child`"
              class="layout-teaser__item layout-teaser__item--tablet-width-50"
              :class="getItemClassByIndex(teaserIndex)"
            >
              <component
                :is="`dpc-api-extension-${
                  ['event', 'media'].includes(teaser.meta.extension)
                    ? teaser.meta.extension
                    : 'basic'
                }`"
                :data="teaser"
              ></component>
            </li>
          </transition-group>
        </template>
      </template>
    </ul>

    <ul
      v-if="isFetchingNextContent"
      class="layout-teaser renderer-layout-teaser__placeholder renderer-layout-teaser__placeholder--next"
    >
      <template v-for="index in placeholderLength" :key="`bottom-${index}`">
        <li
          class="layout-teaser__item layout-teaser__item--tablet-width-50"
          :class="getItemClassByIndex(index - 1)"
        >
          <dpc-teaser-placeholder />
        </li>
      </template>
    </ul>
    <!--div v-else><slot /></div-->
  </div>
</template>

<script setup>
import sortBy from 'lodash/sortBy';
import { computed, toRefs, ref, inject, readonly, unref, watch } from 'vue';

const ITEM_CLASS_MODE_FUNCTION = Object.freeze({
  snake: index => {
    const INDEX_WIDE = [0, 6];

    return [
      `layout-teaser__item--desktop-width-${
        INDEX_WIDE.includes(index) ? '66' : '33'
      }`,
    ];
  },
  normal: index => ['layout-teaser__item--desktop-width-33'],
});

const props = defineProps({
  itemClassMode: {
    type: String,
    default: 'snake',
  },
  filterFunction: {
    type: Function,
  },
  placeholderLength: {
    type: Number,
    default: 10,
  },
});

const { itemClassMode, filterFunction } = toRefs(props);

const responseHistory = inject('api/responseHistory', readonly([]));

const pages = computed(() => {
  const pages = JSON.parse(
    JSON.stringify(sortBy(unref(responseHistory), ['page']))
  );
  if (!filterFunction.value) return pages;

  const filteredPages = pages.map(page => ({
    ...page,
    teaser: page.teaser.filter(filterFunction.value),
  }));
  return filteredPages;
});

const getItemClassByIndex = index => {
  return ITEM_CLASS_MODE_FUNCTION[itemClassMode.value](index);
};

const isFetching = inject('api/isFetching');
const isFetchingPreviousContent = inject(
  'api/paginator/isFetchingPreviousContent',
  ref(false)
);
const isFetchingNextContent = inject(
  'api/paginator/isFetchingNextContent',
  isFetching
);

watch(isFetching, isFetching => {
  if (!isFetching) return;

  const html = document.querySelector('html');
  html.classList.add('has-overflow-anchor-disabled-by-dpc-api-paginator');
});

watch(
  isFetching,
  isFetching => {
    if (isFetching) return;

    const html = document.querySelector('html');
    html.classList.remove('has-overflow-anchor-disabled-by-dpc-api-paginator');
  },
  { flush: 'post' }
);

const prefetchScrollHeight = inject('api/prefetchScrollHeight', readonly(0));
const correctScroll = value => {
  if (!value) return;
  const currentHeight = document.scrollingElement.scrollHeight;
  const currentTop = document.scrollingElement.scrollTop;
  const delta = currentHeight - prefetchScrollHeight.value;
  document.scrollingElement.scrollTop = currentTop + delta;
  console.log('correcting scroll', {
    prefetchHeight: prefetchScrollHeight.value,
    currentHeight,
    currentTop,
    delta,
    newTop: document.scrollingElement.scrollTop,
    loading: document.querySelector('.renderer-layout-teaser__placeholder'),
  });
};
watch(isFetchingPreviousContent, correctScroll, {
  flush: 'post',
});
</script>
